
import electricity from '../../assets/images/BBPS-Electricity.svg';
import pipeGas from "../../assets/images/pipedGas.svg";
import IconApartment from '../../assets/images/Apartment.svg';

import IconBookGas from '../../assets/images/BookGas.svg';
import IconEMI from '../../assets/images/EMI.svg';
import IconCabletv from '../../assets/images/Cabletv.svg';
import IconOTT from '../../assets/images/OTT.svg';
import IconLandline from '../../assets/images/landline.svg';
import IconInsurance from '../../assets/images/Insurance.svg';
import HealthInsurance from '../../assets/images/HealthInsurance.svg';
import IconFastag from '../../assets/images/icon_fastag.svg';
import IconWater from '../../assets/images/waterIcon.svg';
import IconCrditCard from '../../assets/images/bbps-CreditCard.svg';
import IconBroadband from '../../assets/images/bbps-Broadband.svg';
import IconRent from '../../assets/images/icon_rent.svg';
import icon_mobilePrepaid from '../../assets/images/icon_mobilePrepaid.svg';
import icon_dth from '../../assets/images/icon_dth.svg';
import icon_municipalTaxes from '../../assets/images/icon_municipalTaxes.svg';
import icon_housingSociety from '../../assets/images/icon_housingSociety.svg';
import icon_educationFees from '../../assets/images/icon_educationFees.svg';
import icon_donation from '../../assets/images/icon_donation.svg';
import icon_mobilePostpaid from '../../assets/images/icon_mobilePostpaid.svg';
import icon_Hospital from '../../assets/images/Hospital.svg';
import icon_recurringDeposit from '../../assets/images/icon_recurringDeposit.svg';
import icon_clubsAndAssociations from '../../assets/images/icon_clubsAndAssociations.svg';
import icon_ncmc from '../../assets/images/ncmc.svg';
import icon_merto from '../../assets/images/Metro-1.svg';
import HospitalPathology from '../../assets/images/Hospital&Pathology.svg';
import icon_npc from '../../assets/images/icon_nps.svg';
import icon_loanRepayment from '../../assets/images/loanRepayment.svg';
import lifeInsIcon from '../../assets/images/lifeIns.svg';
import muncipalServiceIcon from '../../assets/images/muncipalServices.svg';
import power_meterIcon from '../../assets/images/power-meter.svg';
import b2bIcon from '../../assets/images/b2b.svg';

export const providerTypeOptions = [
  
    {
        label:"Broadband Postpaid",
        value:"BROADBAND POSTPAID",
        img:IconBroadband
    },
    {
        label:"Cable TV",
        value:"CABLE TV",
        img:IconCabletv,
    },
    {
        label:"Clubs & Associations",
        value:"CLUBS AND ASSOCIATIONS",
        img:icon_clubsAndAssociations,
    },
    {
        label:"Credit Card",
        value:"CREDIT CARD",
        img:IconCrditCard,
    },
    {
        label:"Donation",
        value:"DONATION",
        img:icon_donation,
    },
    {
        label:"DTH",
        value:"DTH",
        img:icon_dth,
    },
    {
        label:"Education fees",
        value:"EDUCATION FEES",
        img:icon_educationFees,
    },
    {
        label:"Electricity",
        value:"ELECTRICITY",
        img:electricity
    },
    {
        label:"Fasttag",
        value:"FASTAG",
        img:IconFastag
    },
     
    {
        label:"Gas",
        value:"GAS",
        img:pipeGas,
    },
    
    {
        label:"Health Insurance",
        value:"HEALTH INSURANCE",
        img:HealthInsurance,
    },
    {
        label:"Hospital",
        value:"HOSPITAL",
        img:icon_Hospital,
    },
    {
        label:"Hospital and Pathology",
        value:"HOSPITAL AND PATHOLOGY",
        img:HospitalPathology,
    },
    {
        label:"Housing society",
        value:"HOUSING SOCIETY",
        img:icon_housingSociety,
    },
  
    {
        label:"Insurance",
        value:"INSURANCE",
        img:IconInsurance
    },
    {
        label:"Landline postpaid",
        value:"LANDLINE POSTPAID",
        img:IconLandline
    },
  

    {
        label:"Life Insurance",
        value:"LIFE INSURANCE",
        img:lifeInsIcon
    },
    {
        label:"Loan Repayment",
        value:"LOAN REPAYMENT",
        img:icon_loanRepayment,
    },
    {
        label:"LPG Gas",
        value:"LPG GAS",
        img:IconBookGas
    },
    
    {
        label:"Mobile postpaid",
        value:"MOBILE POSTPAID",
        img:icon_mobilePostpaid,
    },
    {
        label:"Mobile Prepaid",
        value:"MOBILE PREPAID",
        img:icon_mobilePrepaid,
    },
  
    
    {
        label:"Municipal Services",
        value:"MUNICIPAL SERVICES",
        img:muncipalServiceIcon,
    },
    {
        label:"Municipal Taxes",
        value:"MUNICIPAL TAXES",
        img:icon_municipalTaxes,
    },
    {
        label:"Recurring Deposits",
        value:"RECURRING DEPOSIT",
        img:icon_recurringDeposit,
    },
  
    {
        label:"Rental",
        value:"RENTAL",
        img:IconRent,
    },
    {
        label:"Subscription",
        value:"SUBSCRIPTION",
        img:IconOTT
    },
    {
        label:"Water",
        value:"WATER",
        img:IconWater
    },
    {
        label:"NCMC",
        value:"NCMC RECHARGE",
        img:icon_ncmc,
    },
    {
        label:"Metro",
        value:"METRO RECHARGE",
        img:icon_merto,
    },
    {
        label:"NPS",
        value:"NATIONAL PENSION SYSTEM",
        img:icon_npc,
    },
    {
        label:"Prepaid Meter",
        value:"PREPAID METER",
        img:power_meterIcon,
    },
    {
        label:"B2B",
        value:"B2B",
        img:b2bIcon,
    },
]